import { SchedulePayload } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { fetchAllKandidatKey } from "../../queries/Kandidat/useFetchAllKandidat";
import getQueryClient from "../../queryClient";

export async function editSchedule(data: SchedulePayload) {
  const res = await ApiClient.put(`/EditSchedule`, data);
  return res.data;
}

export const useEditSchedule = mutationWrapper(editSchedule, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(fetchAllKandidatKey);
  },
});
